import "../../style.scss";
import styles from "../../MapPopupStyles.js";
import { withStyles } from "@material-ui/core/styles";
import { TableCell, TableHead, TableRow, Tooltip } from "@material-ui/core";
import { getIconByType } from "../../PopupUtil";

const Header = ({
  classes,
  theme,
  infoData,
  name,
  address,
  combinedIconsArray,
}) => {
  return (
    <TableHead className={classes.tableHead}>
      <TableRow className={classes.tableHeadHeight}>
        <TableCell colSpan={2} className={classes.tableHeaderCell}>
          <Tooltip
            classes={{ popper: "popper", tooltip: `tooltip-${theme}` }}
            title={name}
          >
            <div className={classes.customerName}>{name}</div>
          </Tooltip>
          <Tooltip
            classes={{ popper: "popper", tooltip: `tooltip-${theme}` }}
            title={infoData.routeName}
          >
            <span className={classes.routeInfo}>{infoData.routeName}</span>
          </Tooltip>
          <div>
            <Tooltip
              classes={{ popper: "popper", tooltip: `tooltip-${theme}` }}
              title={address}
            >
              <div className={classes.address}>{address}</div>
            </Tooltip>
            <div className={classes.popupIconContainer}>
              {combinedIconsArray.slice(0, 5).map((element) => (
                <Tooltip
                  key={element.value}
                  classes={{ popper: "popper", tooltip: `tooltip-${theme}` }}
                  title={element.tooltip}
                >
                  <div className={classes.popupIcon}>
                    {getIconByType(element)}
                  </div>
                </Tooltip>
              ))}
            </div>
          </div>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default withStyles(styles)(Header);
